module.exports = __webpack_public_path__ + "img/54a5a29515ccdf78b39261fbac39bcc5.png";